module.exports = __webpack_public_path__ + "img/Flag_of_Yemen.209af6bf.svg";